<template>

  <el-dialog title="修改密码" :visible.sync="disvisible" customClass="unpdatepassword way" :append-to-body="true" :before-close="quxiao">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
      <el-form-item label="账号">
        <span>{{ userdata.ccustomername }}</span>
      </el-form-item>
      <el-form-item label="原密码" prop="password">
        <el-input type="password" v-model="dataForm.password"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input type="password" v-model="dataForm.newPassword"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input type="password" v-model="dataForm.confirmPassword"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="quxiao">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    disvisible: {
      type: Boolean,
    },
    userdata: { type: Object },
  },
  data() {
    var validateConfirmPassword = (rule, value, callback) => {
      if (this.dataForm.newPassword !== value) {
        callback(new Error("确认密码与新密码不一致"));
      } else {
        callback();
      }
    };
    return {
      dataForm: {
        password: "",
        newPassword: "",
        confirmPassword: "",
      },

      dataRule: {
        password: [
          { required: true, message: "原密码不能为空", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          { validator: validateConfirmPassword, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    console.log(this.disvisible);
  },

  methods: {
    // 初始化
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
      });
    },
    quxiao() {
      this.$emit("fgtpaw", false);
    },

    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.$confirm(`确定修改密码并重新登录?`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$axios({
              method: "post",
              url: "CommonModule/Op_Supplier/UpdatePwdByTel",
              data: {
                oldPwd: this.dataForm.password,
                newPwd: this.dataForm.newPassword,
              },
            }).then((res) => {
              console.log(res);
              if (res.data.Success) {
                this.$message.success(res.data.Message);
                this.$emit("fgtpaw", false);
                localStorage.clear();
                sessionStorage.clear();
                this.$router.push({ name: "login" });
                this.$store.state.common.mainTabs = [
                  {
                    iframeUrl: "",
                    menuId: "home",
                    name: "home",
                    params: "",
                    query: "",
                    title: "首页",
                  },
                ];
                window.location.reload();
              } else {
                this.$message.error(res.data.Message);
              }
            });
          });
        }
      });
    },
  },
};
</script>

